import { Dialog } from '@cmsgov/ds-medicare-gov';
import React, { useEffect, useState } from 'react';
import { modalImpression } from '../analytics';
import local from '../classes/local';
import '../css/dialog.css';
import translate from '../functions/translate';
import use from '../objects/use';
import Button from './button';
import H1 from './h1';
import StackingButtons from './stacking.buttons';
import { TermsAndConditions } from './terms.and.conditions';
import TranslatedSpan from './translated.span';

const SecurityNoticeDialog = () => {
    const [isOpen, setIsOpen] = useState(!local.getItem('securityNoticeAcknowledged', false));
   
    const headerText = translate('Security Notice');
    useEffect(() => {
        if (isOpen) {
            modalImpression(headerText);
        }
    }, [isOpen, headerText]);

    const data = use.createAccountData;
   
    const cancel = () => {
        local.setItem('securityNoticeAcknowledged', false);
        data.reset();
    };
   
    const getCancelButton = () => {
        return <>
            <Button
                color={'teal'}
                displayAs={'button'}
                fill={'outlined'}
                onClick={cancel}
                size={'small'}
            >
                <TranslatedSpan english={'Cancel'}/>
            </Button>
        </>;
    };
   
    const getOKButton = () => {
        return <>
            <Button
                color={'teal'}
                displayAs={'button'}
                fill={'solid'}
                onClick={ok}
                size={'small'}
            >
                <TranslatedSpan english={'OK'}/>
            </Button>
        </>;
    };
   
    const ok = () => {
        local.setItem('securityNoticeAcknowledged', true);
        setIsOpen(false);
    };
   
    if (!isOpen)
        return null;
    return <>
        <Dialog
            className={'security-notice'}
            getApplicationNode={() => document.getElementById('App')}
            headerClassName={'drawer-dialog-header'}
            underlayClickExits={false}
        >
            <H1>
                {headerText}
            </H1>
            <TermsAndConditions />
            <StackingButtons
                button1={getCancelButton()}
                button2={getOKButton()}
            />
        </Dialog>
    </>
};

export default SecurityNoticeDialog;